import { IconButton, Tooltip } from "@mui/material"
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import DriveFileMoveIcon from '@mui/icons-material/DriveFileMove';

const Module = ({title, icon, description, onClick, onAdd, moduleName}) => {
    return (
        <div className="col-8 col-md-6 col-lg-5 col-xl-3 hive-reporting-module-col">
        <div className="card hive-reporting-module-card">
            <div className="card-body">
                <div className="d-flex align-items-center justify-content-between">
                    <h5 className="mb-0" style={{textAlign: "center"}}>{title}</h5>
                </div>
                <div className="hive-reporting-module-icon" style={{display: "flex", justifyContent: "center"}}>
                    {icon}
                </div>
                <div className="hive-reporting-module-actions" style={{display: "flex", justifyContent: "center"}}>
                    <Tooltip title={description}>
                        <IconButton className="hive-reporting-module-action" onClick={onClick ? onClick : null}>
                            <OpenInNewIcon color={"secondary"} />
                        </IconButton>
                    </Tooltip>
                    {onAdd && <Tooltip title={"Add Module To Dashboard"}>
                        <IconButton className="hive-reporting-module-action" onClick={onAdd ? () => onAdd(moduleName) : null}>
                            <DriveFileMoveIcon color={"secondary"} />
                        </IconButton>
                    </Tooltip>}
                </div>
            </div>
        </div>
        </div>        
    )
}

export default Module
